import React from 'react'
import { Grid, TextField } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import FileUploadDropZone from './FileUploadDropZone'

const ImageTabContent = () => {
  const methods = useFormContext()
  const { register, formState: { errors } } = methods

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          label="Title"
          {...register('title', { required: { value: true, message: 'Invalid Title' } })}
          error={!!errors?.title}
          helperText={errors.title?.message}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <FileUploadDropZone methodName="images" />
      </Grid>
    </Grid>
  )
}

export default ImageTabContent
